import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ChartsModule} from 'ng2-charts/ng2-charts';

import {
    MaterialFormsModule,
    MaterialUserInterfaceModule
} from 'ng2-material-components/ng2-material-components';

// components
import {
    BackgroundComponent,
    DateRangeComponent,
    DateRangeSheetComponent,
    IconActionComponent,
    LocationPickerComponent,
    LocationPickerSheetComponent,
    OverlayComponent,
    SheetComponent,
    PaperCoverComponent,
    PagePreloaderComponent,
    AppPageComponent,
    HorizontalSliderComponent,
    UserFeedbackComponent,
    FilterSheetComponent,
    AsyncContentComponent,
    RibbonMessageComponent,
    DynamicImageComponent,
    UserImageComponent,
} from './ui';

import { NativeChannelService } from './services';

/*Pipes */
import { ToLocalDatePipe, MomentifyPipe } from '../shared/pipes';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        ChartsModule
    ],
    declarations: [
        BackgroundComponent,
        DateRangeComponent,
        DateRangeSheetComponent,
        IconActionComponent,
        LocationPickerComponent,
        LocationPickerSheetComponent,
        OverlayComponent,
        SheetComponent,
        PaperCoverComponent,
        PagePreloaderComponent,
        AppPageComponent,
        HorizontalSliderComponent,
        UserFeedbackComponent,
        FilterSheetComponent,
        AsyncContentComponent,
        RibbonMessageComponent,
        DynamicImageComponent,
        UserImageComponent,
        ToLocalDatePipe,
        MomentifyPipe,
    ],
    exports: [
        BackgroundComponent,
        DateRangeComponent,
        DateRangeSheetComponent,
        IconActionComponent,
        LocationPickerComponent,
        LocationPickerSheetComponent,
        OverlayComponent,
        SheetComponent,
        PaperCoverComponent,
        PagePreloaderComponent,
        AppPageComponent,
        HorizontalSliderComponent,
        UserFeedbackComponent,
        FilterSheetComponent,
        AsyncContentComponent,
        RibbonMessageComponent,
        DynamicImageComponent,
        UserImageComponent,
        ToLocalDatePipe,
        MomentifyPipe,
    ],
    providers: [NativeChannelService]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/shared.module.ts